import type { Locale } from "../Locale.js";

export function getChristmasOfferAnchor(locale: Locale): string {
	return { cs: "#nabidka", en: "#offer" }[locale];
}
